module.exports = __webpack_public_path__ + "img/gitdown1.cf29ca37.png";